import React, { useState, useEffect, useContext } from "react";

import {
  Paper,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Table,
  Stack,
  Button,
} from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { isEmpty } from "lodash";
import { DataContext } from "../../../context/DataContext";
import { isAccess, simpleMessage } from "../../../helpers/Helpers";
import { getToken } from "../../../api/Account";
import NoData from "../../../components/NoData";
import ListFooter from "../../../components/ui/ListFooter";
import SegmentedTabs from "../../../components/ui/SegmentedTabs";

import SmallModal from "../../../components/modals/SmallModal";

import { getConceptoGastosAsync } from "../../../api/Contabilidad";
import AddConceptoGasto from "./AddConceptoGasto";

// El API espera el tipo de gasto como 1/2/3; las pestañas usan indice 0/1/2.
const TIPOS = [
  { label: "Administrativos", id: 1 },
  { label: "Operativos", id: 2 },
  { label: "Otros", id: 3 },
];

const ConceptoGastoList = () => {
  const [conceptoList, setConceptoList] = useState([]);
  const [tipoIndex, setTipoIndex] = useState(0);
  const [localReload, setLocalReload] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const { access, setIsLoading, setIsUnautorized } = useContext(DataContext);

  const token = getToken();
  useEffect(() => {
    (async () => {
      await getData(TIPOS[tipoIndex].id);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localReload]);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsperPage] = useState(10);
  const indexLast = currentPage * itemsperPage;
  const indexFirst = indexLast - itemsperPage;
  const currentItem = conceptoList.slice(indexFirst, indexLast);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleChangeTab = async (index) => {
    setTipoIndex(index);
    setCurrentPage(1);
    await getData(TIPOS[index].id);
  };

  const getData = async (id) => {
    setIsLoading(true);
    const result = await getConceptoGastosAsync(token, id);
    if (!result.statusResponse) {
      setIsLoading(false);
      if (result.error === "Unauthorized") {
        setIsUnautorized(true);
        return;
      }
      simpleMessage(result.error, "error");
      return;
    }
    setConceptoList(result.data.result);
    setIsLoading(false);
  };

  return (
    <div>
      <Paper sx={{ overflow: "hidden" }}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "stretch", sm: "center" }}
          spacing={2}
          flexWrap="wrap"
          sx={{ padding: "18px 22px", borderBottom: "1px solid", borderColor: "divider" }}
        >
          <SegmentedTabs
            tabs={TIPOS.map((tipo) => ({ label: tipo.label }))}
            value={tipoIndex}
            onChange={handleChangeTab}
          />

          {isAccess(access, "CONFIG CREATE") ? (
            <Button
              onClick={() => setShowModal(true)}
              startIcon={<AddRoundedIcon />}
              variant="contained"
              color="primary"
              sx={{ whiteSpace: "nowrap", height: "44px" }}
            >
              Agregar concepto
            </Button>
          ) : null}
        </Stack>

        {isEmpty(currentItem) ? (
          <NoData />
        ) : (
          <>
            <TableContainer sx={{ overflowX: "auto" }}>
              <Table sx={{ minWidth: 480 }}>
                <TableHead>
                  <TableRow>
                    <TableCell align="center">#</TableCell>
                    <TableCell>Concepto</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {currentItem.map((row) => {
                    const { description, id } = row;
                    return (
                      <TableRow key={id} hover>
                        <TableCell align="center" sx={{ color: "text.disabled", fontWeight: 600 }}>
                          {id}
                        </TableCell>
                        <TableCell sx={{ fontWeight: 700, color: "text.primary" }}>{description}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>

            <ListFooter
              data={conceptoList}
              currentCount={currentItem.length}
              indexFirst={indexFirst}
              paginate={paginate}
              itemsperPage={itemsperPage}
              noun="conceptos"
            />
          </>
        )}
      </Paper>

      <SmallModal
        titulo={"Agregar Concepto"}
        isVisible={showModal}
        setVisible={setShowModal}
      >
        <AddConceptoGasto
          setShowModal={setShowModal}
          localReload={localReload}
          setLocalReload={setLocalReload}
        />
      </SmallModal>
    </div>
  );
};

export default ConceptoGastoList;
